module.exports = __webpack_public_path__ + "img/undraw_Data_re_80ws.f155a8fd.svg";